import { render, staticRenderFns } from "./ai-document-analysis.vue?vue&type=template&id=72dd6f67&scoped=true"
import script from "./ai-document-analysis.vue?vue&type=script&lang=js"
export * from "./ai-document-analysis.vue?vue&type=script&lang=js"
import style0 from "./ai-document-analysis.vue?vue&type=style&index=0&id=72dd6f67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd6f67",
  null
  
)

export default component.exports